import { render, staticRenderFns } from "./LanguageChip.vue?vue&type=template&id=5af5b4bd"
import script from "./LanguageChip.vue?vue&type=script&lang=js"
export * from "./LanguageChip.vue?vue&type=script&lang=js"
import style0 from "./LanguageChip.vue?vue&type=style&index=0&id=5af5b4bd&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports